import gql from 'graphql-tag';

export const CREATE_ARTICLES_MUTATION = gql`
  mutation CreateArticles($campaignId: ID!, $urls: [String!]!, $manualExpirationTime: String) {
    createArticles(campaignId: $campaignId, urls: $urls, manualExpirationTime: $manualExpirationTime) {
      results {
        url
        article {
          id
        }
        error
      }
      error
    }
  }
`;
